import { gql } from '@apollo/client';

import { Exercise } from '../../types';
import { exerciseFragment } from '../fragments';

export interface ToggleExercisePracticeMutationVariables {
  courseId: string;
  subjectId: string;
  exerciseId: string;
  action: 'enable-practice' | 'disable-practice';
}

export interface ToggleExercisePracticeMutationResult {
  exercise: Exercise;
}

export const toggleExercisePracticeMutation = gql`
  mutation ToggleExercisePracticeMutation($courseId: String!, $subjectId: String!, $exerciseId: String!, $action: String!) {
    exercise(courseId: $courseId, subjectId: $subjectId, exerciseId: $exerciseId, action: $action, input: {})
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises/{args.exerciseId}/{args.action}", method: "PUT") {
      ...Exercise
    }
  }
  ${exerciseFragment}
`;
